import { PostStore } from './post'
import { OptionStore } from './option'
import { NoticeStore } from './notice'
import { BookmarkPostStore } from './bookmark'
import { HistoryPostStore } from './history'

export const postStore = new PostStore()
export const optionStore = new OptionStore()
export const noticeStore = new NoticeStore()
export const bookmarkStore = new BookmarkPostStore()
export const historyStore = new HistoryPostStore()
